import React from "react";

export default function Pagination(props) {

    const { paginationClassName,
        currentPage,
        totalPages,
        isLoading,
        handlePaginationButtonClick } = props;

    return (
        totalPages > 1 && !isLoading ?
            <nav className={"pagination " + paginationClassName} >
                <button type="button" className="pagination-nav-btn" aria-label="Go to previous page"
                    aria-disabled={currentPage === 1}
                    disabled={currentPage === 1}
                    onClick={() => handlePaginationButtonClick(currentPage - 1)}>
                    <i className="ico-arrow-prev">
                        <svg aria-hidden="true">
                            <use href="/static/images/Boss/svg/BossIconLibrarySprite.svg#ico-arrow-prev"></use>
                        </svg>
                    </i>
                </button>
                <ul className="pagination-list">
                    <li className="pagination-list-item">
                        {`${currentPage}/${totalPages}`}
                    </li>
                </ul>
                <button type="button" className="pagination-nav-btn" aria-label="Go to next page"
                    disabled={currentPage === totalPages}
                    aria-disabled={currentPage === totalPages}
                    onClick={() => handlePaginationButtonClick(currentPage + 1)}>
                    <i className="ico-arrow-next">
                        <svg aria-hidden="true">
                            <use href="/static/images/Boss/svg/BossIconLibrarySprite.svg#ico-arrow-next"></use>
                        </svg>
                    </i>
                </button>
            </nav>
            :
            null
    );
}